//跳转参数
var option={name:'',label:''};

export default {

    /** 重置参数 **/
    RESET_OPTION() {
        option={name:'',label:''};
    },


    //执行跳转
    TRANSLATE_JUMP(label) {
        
        this.RESET_OPTION(); //重置参数
        if(!label || label=='' || label==null) return option; //没有具体跳转参数时直接返回

        if(label=='EsCates') option={name:'商品分类',label:'EsCates'};                      //跳转商品管理页
        if(label=='EsAddCates') option={name:'新增分类',label:'EsAddCates'};                //跳转新增分类
        if(label=='EsEditCates') option={name:'编辑商品',label:'EsEditCates'};              //编辑分类

        if(label=='EsMembers') option={name:'会员信息',label:'EsMembers'};                  //会员信息
        if(label=='EsAddMember') option={name:'新增会员',label:'EsAddMember'};              //新增会员
        if(label=='EsEditMember') option={name:'编辑会员',label:'EsEditMember'};            //编辑会员
        if(label=='EsMemberDetail') option={name:'会员详情',label:'EsMemberDetail'};        //会员详情
        if(label=='EsFrozenMember') option={name:'冻结会员',label:'EsFrozenMember'};        //冻结会员
        if(label=='EsUnFrozenMember') option={name:'解冻会员',label:'EsUnFrozenMember'};    //解冻会员
        if(label=='EsEditAuth') option={name:'编辑会员认证',label:'EsEditAuth'};            //编辑会员认证
        if(label=='EsVip') option={name:'vip管理',label:'EsVip'};                          //vip管理
        if(label=='EsAddVip') option={name:'新增vip',label:'EsAddVip'};                    //新增vip
        if(label=='EsEditVip') option={name:'编辑vip',label:'EsEditVip'};                  //编辑vip
        if(label=='EsVipDetail') option={name:'vip详情',label:'EsVipDetail'};              //vip详情

        if(label=='EsGoods') option={name:'商品信息',label:'EsGoods'}; //商品信息
        if(label=='EsAddGoods') option={name:'添加商品',label:'EsAddGoods'}; //新增商品信息
        if(label=='EsEditGoods') option={name:'编辑商品',label:'EsEditGoods'}; //编辑商品信息
        if(label=='EsGoodsDetail') option={name:'商品详情',label:'EsGoodsDetail'}; //商品详情
        if(label=='EsComment') option={name:'商品评论',label:'EsComment'}; //商品评论
        if(label=='EsLetter') option={name:'私信信息',label:'EsLetter'}; //私信信息

        if(label=='EsFrozen') option={name:'举报记录',label:'EsFrozen'}; //举报记录
        if(label=='EsFrozenDetail') option={name:'举报记录详情',label:'EsFrozenDetail'}; //举报记录详情

        if(label=='EsStatoperates') option={name:'运营数据分析',label:'EsStatoperates'}; //运营分析
        if(label=='EsStatoperateDetail') option={name:'运营数据分析详情',label:'EsStatoperateDetail'}; //运营分析详情

        if(label=='EsRenew') option={name:'续费设置',label:'EsRenew'}; //续费设置
        if(label=='EsAddRenew') option={name:'新增续费设置',label:'EsAddRenew'}; //新增续费设置
        if(label=='EsEditRenew') option={name:'编辑续费设置',label:'EsEditRenew'}; //编辑续费设置
        if(label=='EsRenewDetail') option={name:'续费设置详情',label:'EsRenewDetail'}; //续费设置详情
        if(label=='EsPayment') option={name:'支付设置',label:'EsPayment'}; //支付设置
        if(label=='EsPaymentDetail') option={name:'支付设置详情',label:'EsPaymentDetail'}; //支付设置详情
        if(label=='EsShipping') option={name:'运费设置',label:'EsShipping'}; //运费设置
        if(label=='EsAddShipping') option={name:'新增运费设置',label:'EsAddShipping'}; //新增运费设置
        if(label=='EsEditShipping') option={name:'编辑运费设置',label:'EsEditShipping'}; //编辑运费设置

        if(label=='EsOrder') option={name:'订单管理',label:'EsOrder'}; //订单管理
        if(label=='EsOrderDetail') option={name:'订单详情',label:'EsOrderDetail'}; //订单详情

        if(label=='EsTutarialCate') option={name:'教程分类',label:'EsTutarialCate'}; //教程分类
        if(label=='EsAddTutarialCates') option={name:'新增教程分类',label:'EsAddTutarialCates'}; //新增教程分类
        if(label=='EsEditTutarialCates') option={name:'编辑教程分类',label:'EsEditTutarialCates'}; //编辑教程分类
        if(label=='EsTutarial') option={name:'使用教程',label:'EsTutarial'}; //使用教程
        if(label=='EsAddTutarial') option={name:'使用教程',label:'EsAddTutarial'}; //新增使用教程
        if(label=='EsEditTutarial') option={name:'使用教程',label:'EsEditTutarial'}; //编辑使用教程
        if(label=='EsPromotion') option={name:'自媒体平台推广',label:'EsPromotion'}; //自媒体平台推广
        if(label=='EsAddPromotion') option={name:'新增推广信息',label:'EsAddPromotion'}; //新增推广信息
        if(label=='EsEditPromotion') option={name:'编辑推广信息',label:'EsEditPromotion'}; //编辑推广信息

        if(label=='EsXcxIndex') option={name:'首页设置',label:'EsXcxIndex'}; //小程序首页设置

        if(label=='Banner') option={name:'Banner信息',label:'Banner'}; //Banner信息
        if(label=='AddBanner') option={name:'新增Banner',label:'AddBanner'}; //新增Banner
        if(label=='EditBanner') option={name:'编辑Banner',label:'EditBanner'}; //编辑Banner
        if(label=='SystemPhotos') option={name:'系统图集',label:'SystemPhotos'}; //系统图集
        if(label=='ShopPhotos') option={name:'商户图集',label:'ShopPhotos'}; //商户图集

        if(label=='platFormMenu') option={name:'平台菜单',label:'platFormMenu'}; //平台菜单
        if(label=='PlatFormLevel') option={name:'平台账号版本管理',label:'PlatFormLevel'}; //平台账号版本管理
        if(label=='SetPlatFormLevelAuth') option={name:'设置权限',label:'SetPlatFormLevelAuth'}; //设置权限
        if(label=='PlatFormSetting') option={name:'平台设置',label:'PlatFormSetting'}; //平台设置
        if(label=='PlatFormSettingNew') option={name:'设置管理',label:'PlatFormSettingNew'}; //设置管理

        if(label=='EsEditSetting') option={name:'系统设置',label:'EsEditSetting'}; //系统设置
        if(label=='EsAutoPrice') option={name:'账号认证费用设置',label:'EsAutoPrice'}; //账号认证费用设置
        if(label=='AddEsAutoPrice') option={name:'添加费用设置',label:'AddEsAutoPrice'}; //添加费用设置
        if(label=='EsEditAutoPrice') option={name:'编辑费用设置',label:'EsEditAutoPrice'}; //编辑费用设置

        if(label=='EsCash') option={name:'红包设置',label:'EsCash'}; //红包设置
        if(label=='AddCash') option={name:'新增红包设置',label:'AddCash'}; //新增红包设置
        if(label=='EditCash') option={name:'编辑红包设置',label:'EditCash'}; //编辑红包设置
        if(label=='CashDetail') option={name:'红包设置详情',label:'CashDetail'}; //红包设置详情

        return option;
    },      


}